var IpcPthPadGeneratorData = require('./ipcPthPadGeneratorData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var PathData = require('../../../svg/pathData.js');
var EllipseData = require('../../../svg/ellipseData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var PthComponentAttribute = require('./pthComponentAttribute.js');
var IPCRules = require('../ipcRules');
var IPCPthFootprintCalculator = require('./pthCalculator.js');
var cio_config = require("cio-config");

var HeaderData = function(position, angle, init) {
    var self = this;
    IpcPthPadGeneratorData.apply(this, arguments);

    this.verticalPadCount = this.value("verticalPadCount", true, cio_config.types.positive_int.validator);
    this.horizontalPinPitch = this.value("horizontalPinPitch", true);
    this.pinNumberSequencePattern = this.value("pinNumberSequencePattern", true);
    this.terminalPostLength = this.value("terminalPostLength", true);
    this.footprintOriginLocation = this.value("footprintOriginLocation", true);
    this.footprintOriginLocation(PthComponentAttribute.type.HEADER.footprintOriginLocation["PIN_ONE"]);

    this.pinOneOriginLocation = {
        TOP_LEFT: 0,
        TOP_RIGHT: 1,
        BOTTOM_RIGHT: 2,
        BOTTOM_LEFT: 3
    };

    this.nonTransformedSegmentedGeometry.addTrigger(this.verticalPadCount);
    this.nonTransformedSegmentedGeometry.addTrigger(this.horizontalPinPitch);
    this.nonTransformedSegmentedGeometry.addTrigger(this.pinNumberSequencePattern);
    this.nonTransformedSegmentedGeometry.addTrigger(this.terminalPostLength);
    this.nonTransformedSegmentedGeometry.addTrigger(this.footprintOriginLocation);

    this.terminalWidth.onChange(this, function(value) {
        self.terminalLength(value);
    });
};

lib_core.inherit(HeaderData, IpcPthPadGeneratorData);
lib_core.JsonParser.registerClass(HeaderData, "HeaderData");
module.exports = HeaderData;

HeaderData.prototype.setupMinMaxPtrMap = function() {
    IpcPthPadGeneratorData.prototype.setupMinMaxPtrMap.call(this);
    this.validationMap["horizontalPinPitch"] = [this.horizontalPinPitch];
    this.validationMap["terminalPostLength"] = [this.terminalPostLength];
};

HeaderData.prototype.getTerminalDiameter = function() {
    return Math.sqrt(this.terminalWidth() * this.terminalWidth() + this.terminalLength() * this.terminalLength());
}

/**
 * Calculate pads geometry
 * @param  {boolean} absolutePositions
 * @return {array} Array of pads.
 */
HeaderData.prototype.getPads = function(absolutePositions) {
    var nRow = this.verticalPadCount();
    var nCol = this.horizontalPadCount();
    var motif = this.getMotif();
    var pads = [];

    //pads location depends on pin number sequence pattern
    var PinNumberSequencePattern = PthComponentAttribute.type.HEADER.pinNumberSequencePattern;

    //TODO: support more patterns
    switch(this.pinNumberSequencePattern()) {
        /*
            2 4 6 8 10
            1 3 5 7 9
         */
        case PinNumberSequencePattern["ZZBT"].key:
            for(var j = 0; j < nCol; j++) {
                for(var i = 0; i < nRow; i++) {
                    var pad = motif.clone();
                    pad.move(new lib_geometry.Coord(this.horizontalPinPitch() * j, this.verticalPinPitch() * i));
                    pads.push(pad);
                }
            }
        break;

        /*
           10 9 8 7 6
            1 2 3 4 5
         */
        case PinNumberSequencePattern["LRCCW"].key:
            for(var i = 0; i < nRow; i++) {
                for(var j = 0; j < nCol; j++) {
                    var pad = motif.clone();

                    if(i % 2 === 0) {
                        pad.move(new lib_geometry.Coord(this.horizontalPinPitch() * j, this.verticalPinPitch() * i));
                    } else {
                        pad.move(new lib_geometry.Coord(this.horizontalPinPitch() * (nCol - j - 1), this.verticalPinPitch() * i));
                    }

                    pads.push(pad);
                }
            }
        break;

        /*
            1 2 3 4 5
           10 9 8 7 6
         */
        case PinNumberSequencePattern["LRCW"].key:
            for(var i = 0; i < nRow; i++) {
                for(var j = 0; j < nCol; j++) {
                    var pad = motif.clone();

                    if(i % 2 === 0) {
                        pad.move(new lib_geometry.Coord(this.horizontalPinPitch() * j, -this.verticalPinPitch() * i));
                    } else {
                        pad.move(new lib_geometry.Coord(this.horizontalPinPitch() * (nCol - j - 1), -this.verticalPinPitch() * i));
                    }

                    pads.push(pad);
                }
            }
        break;
    }

    if(this.footprintOriginLocation() === PthComponentAttribute.type.HEADER.footprintOriginLocation["CENTER_PADS"]) {
        var pinOneOriginPositionId = PthComponentAttribute.type.HEADER.pinNumberSequencePattern[this.pinNumberSequencePattern()].pinOnePositionId;
        var moveDirY;

        if(pinOneOriginPositionId == this.pinOneOriginLocation.TOP_LEFT || pinOneOriginPositionId == this.pinOneOriginLocation.TOP_RIGHT) {
            moveDirY = 1;
        } else {
            moveDirY = -1;
        }

        var moveVec = new lib_geometry.Coord(-this.horizontalPinPitch() * (nCol - 1) / 2, moveDirY * this.verticalPinPitch() * (nRow - 1) / 2);

        pads.forEach(function(pad) {
            pad.move(moveVec);
        });
    }

    this.updatePads(pads, absolutePositions);
    return pads;
};

HeaderData.prototype.getFootprintPadsBBox = function(pads) {
    console.assert(pads.length, "There are no pads to calculate bbox.")

    var padsBoundingBox = null;

    pads.forEach(function(pad) {
        var padBB = pad.boundingBox && pad.boundingBox();
        if(padBB) padsBoundingBox = padBB.merge(padsBoundingBox);
    });

    return padsBoundingBox;
};
